module.exports = __webpack_public_path__ + "media/icons/white-archive-936fbb61.png";